import Stack, { StackProps } from "react-bootstrap/Stack";

export type { StackProps };

export default Stack;
